import * as UAParser from "ua-parser-js";
import AnalyticsAPIURL from "../config/apiURL/analyticsAPIURL";
import { POST } from "../config/httpMain";
import { APPNAME, COMPANYCODE } from "../constants/constant";
import { errorHandler } from "./errorHandler";
import { useAppSelector } from "../store";
import { startTransition } from "react";

function getSessionId() {
    let sid = localStorage.getItem("session_id");
    if (!sid) {
        sid = crypto.randomUUID();
        localStorage.setItem("session_id", sid);
    }
    return sid;
}
export async function trackPageView(pageUrl: any, userId: any, durationSeconds?: any) {
    //startTransition(() => {
        const sessionId = getSessionId();

        const urlParams = new URLSearchParams(window.location.search);
        const parser = new (UAParser as any).UAParser(navigator.userAgent);
        const result = parser.getResult();

        const browserName = result.browser.name || "Unknown";
        const browserVersion = result.browser.version || "Unknown";
        const os = result.os.name || "Unknown";
        const deviceType = result.device.type || "Desktop"; // could be 'mobile', 'tablet', etc.
        const userAgent = navigator.userAgent;

        const data = {
            companyCode: COMPANYCODE,
            appName: document?.URL || APPNAME,
            userId: userId?.toString(),
            sessionId,
            pageUrl: pageUrl,
            pageTitle: document.title,
            referrer: document.referrer,
            userAgent: userAgent,
            browser: browserName,
            browserVersion: browserVersion,
            os: os,
            deviceType: deviceType,
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight,
            durationSeconds: durationSeconds,
            UtmSource: urlParams.get("utm_source"),
            UtmMedium: urlParams.get("utm_medium"),
            UtmCampaign: urlParams.get("utm_campaign")
        };

      await POST(AnalyticsAPIURL.AddTrackPage, data).then((response: any) => {
            if (response?.data?.isSuccess) {

            }
            else {
                errorHandler("response", response);
            }
        }).catch((e: any) => {
            errorHandler("error", e);
        });
    //});
}